import { Component, Input, OnInit } from "@angular/core";
import { RegionService } from "../../../routes/services/region.service";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { GlobalFunction } from "../../../routes/services/globalFuntion";
import { FuzzyLogicComponentService } from "./services/fuzzy_logic.service";
import { StorageService } from "../../../routes/services/storage.service";
import { configFuzzyLogic, setConfigFuzzyLogic } from "./interfaces/fuzzy_logic.interfaces";
import { TranslatorService } from "../../../core/translator/translator.service";

@Component({
  selector: "app-config-fuzzy-logic",
  templateUrl: "./fuzzy_logic.html",
  styleUrls: ["./fuzzy_logic.scss"]
})
export class ConfigFuzzyLogicComponent implements OnInit {
  @Input() id: null | number = null;
  @Input() type: "region" | "client" | "farm" = "region";

  configForm: FormGroup | undefined;
  testForm: FormGroup | undefined;
  levelKeys = ["very_low", "low", "normal", "high", "very_high"];
  subLevelKeys = ["low", "normal", "high"];
  config_selected = "Temperatura";
  name = "";
  configuration: configFuzzyLogic | null = null;
  config = [
    {
      title: "Temperatura",
      prop: "temperature_terms",
      very_low: {
        low: "",
        normal: "",
        high: ""
      },
      low: {
        low: "",
        normal: "",
        high: ""
      },
      normal: {
        low: "",
        normal: "",
        high: ""
      },
      high: {
        low: "",
        normal: "",
        high: ""
      },
      very_high: {
        low: "",
        normal: "",
        high: ""
      }
    },
    {
      title: "Oxigeno",
      prop: "oxygen_terms",
      very_low: {
        low: "",
        normal: "",
        high: ""
      },
      low: {
        low: "",
        normal: "",
        high: ""
      },
      normal: {
        low: "",
        normal: "",
        high: ""
      },
      high: {
        low: "",
        normal: "",
        high: ""
      },
      very_high: {
        low: "",
        normal: "",
        high: ""
      }
    },
    {
      title: "Ajuste",
      prop: "modifier_terms",
      very_low: {
        low: "",
        normal: "",
        high: ""
      },
      low: {
        low: "",
        normal: "",
        high: ""
      },
      normal: {
        low: "",
        normal: "",
        high: ""
      },
      high: {
        low: "",
        normal: "",
        high: ""
      },
      very_high: {
        low: "",
        normal: "",
        high: ""
      }
    }
  ];
  resultTest: any = null;
  view_ajust = true;

  loading_petition: boolean = false;
  constructor(
    private fb: FormBuilder,
    public fuzzyLogicService: FuzzyLogicComponentService,
    public globalFunction: GlobalFunction,
    public storageService: StorageService,
    public translatorService: TranslatorService
  ) {
    this.testForm = this.testForm = this.fb.group({
      temperature: this.fb.control("", Validators.required),
      oxygen: this.fb.control("", Validators.required),
      feeding_kgs: this.fb.control(1)
    });

    this.configForm = this.fb.group({
      configurations: this.fb.array([]),
      name: this.fb.control("", Validators.required)
    });
  }

  ngOnInit(): void {
    console.log(this.type, this.id);

    if (this.id) {
      this.getConfig();
    }

    this.config.forEach((configItem) => {
      const configGroup = this.fb.group({
        title: [configItem.title],
        very_low: this.createLevelGroup(configItem.very_low),
        low: this.createLevelGroup(configItem.low),
        normal: this.createLevelGroup(configItem.normal),
        high: this.createLevelGroup(configItem.high),
        very_high: this.createLevelGroup(configItem.very_high)
      });
      if (this.configurations) {
        this.configurations.push(configGroup);
      }
    });
  }

  get configurations(): FormArray | undefined {
    if (this.configForm) {
      return this.configForm.get("configurations") as FormArray;
    }
  }

  createLevelGroup(levelData: any): FormGroup {
    return this.fb.group({
      low: [levelData.low, Validators.required],
      normal: [levelData.normal, Validators.required],
      high: [levelData.high, Validators.required]
    });
  }

  setValueInputs = (resp: any) => {
    this.config.forEach((config, idx) => {
      const levels = ["very_low", "low", "normal", "high", "very_high"];
      const subLevels = ["low", "normal", "high"];

      const value = levels.reduce((acc: any, level: any, i) => {
        acc[level] = subLevels.reduce((subAcc: any, subLevel: any, j) => {
          subAcc[subLevel] = resp ? resp[config.prop][i][j] : "";
          return subAcc;
        }, {});
        return acc;
      }, {});
      if (this.configurations) {
        this.configurations.controls[idx].setValue({
          title: config.title,
          ...value
        });
      }
      if (this.configForm) {
        this.configForm.controls["name"].setValue(resp.name);
      }
    });
  };
  getType = () => {
    const object_type = {
      region: "REGION",
      client: "CLIENTS",
      farm: "CLIENTS"
    };

    return (object_type[this.type] ?? "REGION") as "REGION" | "CLIENTS";
  };
  getConfig() {
    let id = this.id;
    if (this.type === "farm") {
      id = this.storageService.getClientID();
    }
    if (id) {
      this.fuzzyLogicService.getConfigFuzzyLogic(id, this.getType()).subscribe((resp) => {
        console.log(resp);
        if (resp && resp.name) {
          this.configuration = resp;
          this.setValueInputs(resp);
        }
      });
    }
  }

  transformarConfiguracion(): setConfigFuzzyLogic | undefined {
    const construct_value = (val: any) => {
      const levels = ["very_low", "low", "normal", "high", "very_high"];
      const subLevels = ["low", "normal", "high"];
      let value: any = levels.map((item) => []);
      levels.forEach((level, idx) => {
        subLevels.forEach((sublevel, idxSub) => {
          value[idx][idxSub] = val[level][sublevel];
        });
      });
      return value;
    };
    if (this.configForm) {
      const body = {
        name: this.configForm.value.name,
        oxygen_terms: construct_value(this.configForm.value.configurations[1]),
        temperature_terms: construct_value(this.configForm.value.configurations[0]),
        modifier_terms: construct_value(this.configForm.value.configurations[2])
      };

      return body;
    }
    return undefined;
  }

  setConfig() {
    const body = this.transformarConfiguracion();
    let id = this.id;
    this.loading_petition = true;
    if (this.type === "farm") {
      id = this.storageService.getClientID();
    }
    if (id && body) {
      this.fuzzyLogicService.setConfigFuzzyLogic(id, body, this.getType()).subscribe(
        (resp) => {
          this.loading_petition = false;

          this.globalFunction.animation(
            "success",
            "¡Enhorabuena!",
            "Se guardo la configuración correctamente"
          );
        },
        (error) => {
          this.loading_petition = false;
        }
      );
    }
  }
  deleteConfig = async () => {
    let id = this.id;
    if (this.type === "farm") {
      id = this.storageService.getClientID();
    }
    if (id) {
      let bool = await this.globalFunction.optionSwalAlert(
        this.translatorService.translate("general.delete-item-confirm", {
          value: this.translatorService.translate("fuzzy-logic-config.this-config")
        })
      );

      bool &&
        this.fuzzyLogicService.deleteConfigFuzzyLogic(id, this.getType()).subscribe((resp) => {
          this.setValueInputs("");
        });
    }
  };
  viewTitle = (val: "very_low" | "low" | "normal" | "high" | "very_high") => {
    const obj = {
      very_low: "fuzzy-logic-config.very-low",
      low: "clients.ranking.best-size.low",
      normal: "fuzzy-logic-config.medium",
      high: "speed-config.high",
      very_high: "fuzzy-logic-config.very-high"
    };
    return obj[val] ? this.translatorService.translate(obj[val]) : "";
  };
  testConfig() {
    const configuration = this.transformarConfiguracion();
    if (configuration) {
      const { modifier_terms, oxygen_terms, temperature_terms } = configuration;
      if (this.testForm) {
        this.fuzzyLogicService
          .testConfigFuzzyLogic({
            ...this.testForm.value,
            config: {
              modifier_terms,
              oxygen_terms,
              temperature_terms
            }
          })
          .subscribe((resp) => {
            const { modifier, new_feeding_kgs, old_feeding_kgs } = resp;
            this.resultTest = { modifier, new_feeding_kgs, old_feeding_kgs };
          });
      }
    }
  }
}
